const SDK_VERSION = '7.67.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
